import { WalletBalance } from "../modules/walletBalance";

export const WalletBalancePage = () => {
  return <WalletBalance />;
};
